import * as React from "react";
import { FC } from "react";
import { Datagrid, FunctionField, ListProps, TextField } from "react-admin";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { useAccessControl } from "@airborne/react-admin";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const PbhRequestStatusInfoList: FC<ListProps> = props => {
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl(props.resource as any);

  return (
    <PoolList
      {...props}
      sort={DefaultCreatedDateSort}
      perPage={DefaultPerPageSize}
      resource={props.resource}
      bulkActionButtons={false}
      title="REQUEST STATUS INFO"
    >
      <Datagrid rowClick={canEdit ? "edit" : ""}>
        <FunctionField
          style={{ fontSize: 12 }}
          label="Status"
          render={(record: any) => Math.floor(record.requestStatus / 1)}
        />
        <TextField source="displayName" label="Display Name" />
      </Datagrid>
    </PoolList>
  );
};

export default PbhRequestStatusInfoList;
